(async () => {
	void (
		await import('./components/DstEmergencyBroadcast/DstEmergencyBroadcast.webcomponent.svelte')
	).default;
})();
